import { render, staticRenderFns } from "./ReportManage.vue?vue&type=template&id=37018075&scoped=true&"
import script from "./ReportManage.vue?vue&type=script&lang=js&"
export * from "./ReportManage.vue?vue&type=script&lang=js&"
import style0 from "./ReportManage.vue?vue&type=style&index=0&id=37018075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37018075",
  null
  
)

export default component.exports